export class CategoryDto {
  id: number;
  label: string;
  imageURL: string;
  isMain: boolean;
}

